<template>
    <div class="d-flex flex-wrap flex-stack my-5">
        <h2 class="fs-2 fw-bold my-2">
            {{ $t('pages.module.eTep.question.save.' + (questionID ? 'editQuestion' : 'newQuestion')) }}
        </h2>
        <router-link to="/module/etep/question" class="btn btn-primary align-self-center">
            <span class="svg-icon svg-icon-2">
                <inline-svg src="/media/icons/duotune/arrows/arr021.svg"/>
            </span>
            {{ $t("pages.module.eTep.question.title") }}
        </router-link>
    </div>
    <el-tabs v-model="tabModel" class="question-tabs overflow-visible-tabs">
        <el-tab-pane :label="$t('pages.module.eTep.question.save.tabs.generalDetails')" name="general">
            <el-form :model="form" ref="questionForm">
                <div class="row g-6 mb-6 g-xl-9 mb-xl-9">
                    <div class="col-md-8">
                        <div class="card mb-4">
                            <div class="card-body d-flex flex-column p-9">
                                <div class="fv-row">
                                    <el-form-item prop="data.alias" class="m-0">
                                        <label class="fs-6 fw-bold mb-2">{{ $t('pages.module.eTep.question.save.cols.title') }}</label>
                                        <el-input v-model="form.data.alias"></el-input>
                                        <small class="text-muted">Bu alana, soruyu sınava eklerken kolayca bulabilmeniz için hatırlatıcı bir takma ad girebilirsiniz.</small>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                        <div v-if="selectedQuestionTypes && selectedQuestionTypes.code === 'PARAGRAPH'">
                            <paragraph :data="form.data.data" :sub-question-types="subQuestionTypes" :sub-questions="form.data.sub_questions" :update-status="form.updateStatus" @load-question="loadQuestion(questionID)"/>
                        </div>
                        <div v-if="selectedQuestionTypes && selectedQuestionTypes.code === 'PARAGRAPH_DRAG_FILL'">
                            <paragraph-drag-fill :data="form.data.data" :answers="form.data.answers" :update-status="form.updateStatus" :correctAnswer="form.data.correct_answer" @load-question="loadQuestion(questionID)"/>
                        </div>
                        <div v-if="selectedQuestionTypes && selectedQuestionTypes.code === 'PARAGRAPH_DRAG_CORRECT_SORT'">
                            <paragraph-drag-correct-sort :data="form.data.data" :answers="form.data.answers" :update-status="form.updateStatus" :correctAnswer="form.data.correct_answer" @load-question="loadQuestion(questionID)"/>
                        </div>
                        <div v-if="selectedQuestionTypes && selectedQuestionTypes.code === 'LISTEN'">
                            <listen :image="image" :track="track" :data="form.data.data" :sub-question-types="subQuestionTypes" :sub-questions="form.data.sub_questions" :update-status="form.updateStatus" @load-question="loadQuestion(questionID)"/>
                        </div>
                        <div v-if="selectedQuestionTypes && selectedQuestionTypes.code === 'LISTEN_TABLE'">
                            <listen-table :image="image" :track="track" :data="form.data.data" :correctAnswer="form.data.correct_answer" @load-question="loadQuestion(questionID)"/>
                        </div>
                        <div v-if="selectedQuestionTypes && selectedQuestionTypes.code === 'SPEAK_PARAGRAPH'">
                            <speak-paragraph :data="form.data.data" @load-question="loadQuestion(questionID)"/>
                        </div>
                        <div v-if="selectedQuestionTypes && selectedQuestionTypes.code === 'SPEAK_LISTEN'">
                            <speak-listen :track="track" :data="form.data.data" @load-question="loadQuestion(questionID)"/>
                        </div>
                        <div v-if="selectedQuestionTypes && selectedQuestionTypes.code === 'WRITE_PARAGRAPH'">
                            <write-paragarph :track="track" :data="form.data.data" @load-question="loadQuestion(questionID)"/>
                        </div>
                        <div v-if="selectedQuestionTypes && selectedQuestionTypes.code === 'WRITE_CHART_LISTEN'">
                            <write-chart-listen :image="image" :track="track" :data="form.data.data" @load-question="loadQuestion(questionID)"/>
                        </div>
                        <div class="card mt-7">
                            <div class="card-header">
                                <h2 class="card-title fw-bolder">{{ $t('pages.module.eTep.question.save.alertArea.title') }}</h2>
                            </div>
                            <div class="card-body d-flex flex-column">
                                <div v-if="form.data.data.alert_area && form.data.data.alert_area.length">
                                    <div class="fv-row" v-for="(item, index) in form.data.data.alert_area" :key="index" :class="[(index > 0), 'mt-10']">
                                        <div v-if="item.type === 'alert'" class="border border-gray-300 pt-5 pb-0 px-3 rounded">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <div class="d-flex align-items-center justify-content-between mb-4">
                                                        <label class="fs-6 fw-bold">{{ $t('pages.module.eTep.question.save.alertArea.label.' + item.type) }}</label>
                                                        <button class="btn btn-danger btn-sm" type="button" @click="removeAlertArea(index)"><i class="bi bi-trash"/> Kaldır</button>
                                                    </div>
                                                </div>
                                                <div class="col-md-12">
                                                    <el-form-item :prop="'data.data.alert_area[' + index + '].content'" :rules="$validation.getMessage(['required'])">
                                                        <label class="required fs-6 fw-bold">{{ $t('pages.module.eTep.question.save.alertArea.label.text') }}</label>
                                                        <el-input v-model="item.content"/>
                                                    </el-form-item>
                                                </div>
                                                <div class="col-md-6">
                                                    <el-form-item>
                                                        <el-select v-model="item.color" class="w-100">
                                                            <el-option value="success" :label="$t('pages.module.eTep.question.save.alertArea.color.green')"></el-option>
                                                            <el-option value="info" :label="$t('pages.module.eTep.question.save.alertArea.color.blue')"></el-option>
                                                            <el-option value="warning" :label="$t('pages.module.eTep.question.save.alertArea.color.orange')"></el-option>
                                                            <el-option value="danger" :label="$t('pages.module.eTep.question.save.alertArea.color.red')"></el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                </div>
                                                <div class="col-md-6">
                                                    <el-form-item>
                                                        <el-select v-model="item.icon" class="w-100">
                                                            <el-option value="info" :label="$t('pages.module.eTep.question.save.alertArea.icons.info')"><i class="fa fa-info-circle"></i> {{ $t('pages.module.eTep.question.save.alertArea.icons.info') }}</el-option>
                                                            <el-option value="calendar" :label="$t('pages.module.eTep.question.save.alertArea.icons.calendar')"><i class="fa fa-calendar-alt"></i> {{ $t('pages.module.eTep.question.save.alertArea.icons.calendar') }}</el-option>
                                                            <el-option value="triangle" :label="$t('pages.module.eTep.question.save.alertArea.icons.triangle')"><i class="fa fa-exclamation-triangle"></i> {{ $t('pages.module.eTep.question.save.alertArea.icons.triangle') }}</el-option>
                                                            <el-option value="tick" :label="$t('pages.module.eTep.question.save.alertArea.icons.tick')"><i class="fa fa-check-square"></i> {{ $t('pages.module.eTep.question.save.alertArea.icons.tick') }}</el-option>
                                                            <el-option value="danger" :label="$t('pages.module.eTep.question.save.alertArea.icons.danger')"><i class="fa fa-exclamation-circle"></i> {{ $t('pages.module.eTep.question.save.alertArea.icons.danger') }}</el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else class="border border-gray-300 pt-5 px-3 pb-0 rounded">
                                            <div class="d-flex align-items-center justify-content-between mb-4">
                                                <label class="required fs-6 fw-bold">{{ $t('pages.module.eTep.question.save.alertArea.label.' + item.type) }}</label>
                                                <button class="btn btn-danger btn-sm" type="button" v-on:click="removeAlertArea(index)"><i class="bi bi-trash"/> Kaldır</button>
                                            </div>
                                            <el-form-item :prop="'data.data.alert_area[' + index + '].content'" :rules="$validation.getMessage(['required'])">
                                                <CustomCkeditor :model="item.content" @updateModel="item.content = $event"></CustomCkeditor>
                                            </el-form-item>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <p class="text-gray-600 text-center">{{ $t('pages.module.eTep.question.save.alertArea.addAlertContent') }}</p>
                                    <div class="d-flex flex-column flex-md-row align-items-center justify-content-center gap-3">
                                        <button class="btn btn-flex btn-primary" v-on:click="addAlertArea('alert')" type="button">
                                        <span class="svg-icon svg-icon-2">
                                            <inline-svg src="/media/icons/duotune/arrows/arr075.svg"/>
                                        </span>
                                            {{ $t('pages.module.eTep.question.save.alertArea.alertAdd') }}
                                        </button>
                                        <button class="btn btn-flex btn-primary" v-on:click="addAlertArea('text')" type="button">
                                        <span class="svg-icon svg-icon-2">
                                            <inline-svg src="/media/icons/duotune/arrows/arr075.svg"/>
                                        </span>
                                            {{ $t('pages.module.eTep.question.save.alertArea.contentAdd') }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="card-footer" v-if="form.data.data.alert_area && form.data.data.alert_area.length" ref="addSectionFooter">
                                <div class="d-flex flex-column flex-md-row align-items-center justify-content-start gap-3">
                                    <button class="btn btn-flex btn-primary" v-on:click="addAlertArea('alert')" type="button">
                                        <span class="svg-icon svg-icon-2">
                                            <inline-svg src="/media/icons/duotune/arrows/arr075.svg"/>
                                        </span>
                                        {{ $t('pages.module.eTep.question.save.alertArea.alertAdd') }}
                                    </button>
                                    <button class="btn btn-flex btn-primary" v-on:click="addAlertArea('text')" type="button">
                                        <span class="svg-icon svg-icon-2">
                                            <inline-svg src="/media/icons/duotune/arrows/arr075.svg"/>
                                        </span>
                                        {{ $t('pages.module.eTep.question.save.alertArea.contentAdd') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="card-sticky-top">
                            <div class="card">
                                <div class="card-body d-flex flex-column p-9">
                                    <div class="fv-row mb-1">
                                        <label class="required fs-6 fw-bold mb-2">{{ $t('pages.module.examManagement.question.save.cols.category') }}</label>
                                        <el-form-item prop="data.category_id" :rules="$validation.getMessage(['required'])">
                                            <el-input type="hidden" v-model="form.data.category_id"></el-input>
                                            <el-select-tree :value="form.data.category_id" @input="form.data.category_id = $event" :data="treeCategories" :multiple="false" :placeholder="$t('common.chooseSelect')"/>
                                        </el-form-item>
                                    </div>
                                    <div v-if="!form.updateStatus">
                                        <label class="required fs-6 fw-bold mb-2">{{ $t('pages.module.eTep.question.save.cols.section.type') }}</label>
                                        <el-form-item prop="data.section_id" :rules="$validation.getMessage(['required'])">
                                            <el-select v-model="form.data.section_id" class="w-100" :placeholder="$t('common.chooseSelect')" @change="loadQuestionType(false)" :disabled="form.updateStatus">
                                                <el-option v-for="(type, typeIndex) in treeSections" :key="typeIndex" :value="type.id" :label="type.name"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                    <div class="fv-row mb-1" v-if="form.data.section_id || form.updateStatus">
                                        <label class="required fs-6 fw-bold mb-2">{{ $t('pages.module.eTep.question.save.cols.question.type') }}</label>
                                        <el-form-item prop="data.question_type_id" :rules="$validation.getMessage(['required'])">
                                            <el-select v-model="form.data.question_type_id" class="w-100" :placeholder="$t('common.chooseSelect')" :disabled="form.updateStatus" @change="changeQuestionType">
                                                <el-option v-for="(type, typeIndex) in questionTypes" :key="typeIndex" :value="type.id" :label="$t('pages.module.eTep.questionType.' + type.code)"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                    <div class="fv-row mt-5">
                                        <el-form-item class="mb-0">
                                            <button @click.prevent="onSubmit" :data-kt-indicator="form.loading ? 'on' : null" class="btn btn-lg btn-primary w-100" type="button">
                                                <span v-if="!form.loading" class="indicator-label">{{ $t("btn.save") }}</span>
                                                <span v-if="form.loading" class="indicator-progress">
                                                    {{ $t("messages.wait") }}
                                                    <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                                </span>
                                            </button>
                                        </el-form-item>
                                    </div>
                                </div>
                            </div>
                            <div class="card mt-7" v-if="typeof form.data.correct_answer === 'object' && form.data.question_type.code === 'PARAGRAPH_DRAG_CORRECT_SORT'">
                                <div class="card-header">
                                    <h2 class="card-title fw-bolder">{{ $t('pages.module.eTep.question.save.questionType.paragraphDragCorrectSort.correctAnswer.title') }}</h2>
                                </div>
                                <div class="card-body d-flex flex-column p-9">
                                    <div class="fv-row mb-1">
                                        <el-form-item v-for="(correctAnswer, correctAnswerIndex) in form.data.data.drag_content_count" :key="correctAnswer" :rules="$validation.getMessage(['required'])">
                                            <el-select class="w-100" v-model="form.data.correct_answer[ correctAnswerIndex ]">
                                                <el-option v-for="(answer, answerIndex) in form.data.answers.filter(a => a.id)" :key="answerIndex" :value="answer.id" :label="answer.data.content.replace(/<\/?[^>]+(>|$)/g, '').slice(0, 100)"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-form>
        </el-tab-pane>
    </el-tabs>
</template>

<script>
import ElSelectTree from "@/components/ElSelectTree.vue";
import CustomCkeditor from "@/components/custom-ckeditor";
import Paragraph from "@/components/module/etep/question-types/paragraph";
import ParagraphDragFill from "@/components/module/etep/question-types/paragraph-drag-fill";
import ParagraphDragCorrectSort from "@/components/module/etep/question-types/paragraph-drag-correct-sort";
import Listen from "@/components/module/etep/question-types/listen";
import ListenTable from "@/components/module/etep/question-types/listen-table";
import SpeakParagraph from "@/components/module/etep/question-types/speak-paragraph";
import SpeakListen from "@/components/module/etep/question-types/speak-listen";
import WriteParagarph from "@/components/module/etep/question-types/write-paragarph";
import WriteChartListen from "@/components/module/etep/question-types/write-chart-listen";

export default {
    name: "_id",
    components: {
        ElSelectTree,
        CustomCkeditor,
        Paragraph,
        ParagraphDragFill,
        ParagraphDragCorrectSort,
        Listen,
        ListenTable,
        SpeakParagraph,
        SpeakListen,
        WriteParagarph,
        WriteChartListen
    },
    data() {
        return {
            tabModel: 'general',
            form: {
                updateStatus: false,
                loading: false,
                translate: {
                    language_id: this.$root.defaultLanguage.id
                },
                data: {
                    section_id: '',
                    question_type_id: 1,
                    data: {
                        "alert_area": [],
                        "paragraphs": [],
                        "contents": [],
                        "content": "",
                        "drag_content_count": 1,
                        "options": {
                            "before_play_waiting_second": 30,
                            "before_record_waiting_second": 10,
                            "max_record_second": 45,
                            "min_word": 20,
                            "max_word": 50,
                        },
                        "table": {
                            "row": [],
                            "column": []
                        },
                    },
                    sub_questions: [],
                    answers: []
                },
            },
            question: {
                translate: {}
            },
            treeSections: [],
            questionTypes: [],
            treeCategories: [],
            image: {
                dialogImageUrl: '',
                dialogVisible: false,
                uploadList: [],
                fileList: []
            },
            track: {
                dialogTrackUrl: '',
                dialogVisible: false,
                uploadList: [],
                fileList: []
            },

            processLength: 0,
            errorLength: 0,
        }
    },
    computed: {
        questionID() {
            return this.$route.params.id;
        },
        selectedSectionTypes() {
            return this.treeSections.find(item => item.id === this.form.data.section_id) ?? {};
        },
        selectedQuestionTypes() {
            return this.questionTypes.find(item => item.id === this.form.data.question_type_id);
        },
        subQuestionTypes() {
            return this.questionTypes.find(item => item.id === this.form.data.question_type_id)?.sub_question_types ?? [];
        },
        errorStatus() {
            let status = 'successful';
            if (this.errorLength !== 0 && this.errorLength === this.processLength) {
                status = 'failed';
            } else if (this.errorLength > 0 && this.errorLength !== this.processLength) {
                status = 'partiallySuccessful';
            } else if (this.errorLength === this.processLength) {
                status = 'successful';
            }
            return status;
        }
    },
    created() {
        if (this.questionID && !(this.questionID > 0)) {
            this.$router.push({
                path: "/module/etep/question"
            });
        }
    },
    mounted() {
        this.setCurrentPageBreadcrumbs(this.$t('pages.module.eTep.question.save.' + (this.questionID ? 'editQuestion' : 'newQuestion')), [this.$t("menu.moduleManagement"), this.$t("pages.module.eTep.title"), this.$t("pages.module.eTep.question.title")]);
        this.loadTreeCategories();
        this.loadTreeSections();
        this.loadQuestionType(() => {
            if (this.questionID && this.questionID > 0) {
                this.loadQuestion();
            }
        });
    },
    methods: {
        loadQuestion(questionID = this.questionID) {
            this.axios.get(this.endpoints['module_etep_question'] + '/' + questionID).then((response) => {
                let data = response.data.data;
                this.form.updateStatus = true;
                this.question = data;
                this.selectedSectionTypes = data.question_type;
                this.form.data = data;
                this.form.data.section_id = '';
                this.form.data.question_type_id = data.question_type_id;
                if (data.question_type.code === 'PARAGRAPH_DRAG_FILL') {
                    this.form.data.correct_answer = data.data.contents.filter(item => item.type === 'drag_content').reduce((acc, item) => {
                        acc[item.hash] = this.form.data.correct_answer_human ? this.form.data.correct_answer_human[item.hash] : null;
                        return acc;
                    }, {});
                }
                if (data.question_type.code === 'LISTEN_TABLE') {
                    this.form.data.correct_answer = data.data.table.row.reduce((acc, item) => {
                        acc[item.hash] = this.form.data.correct_answer_human ? this.form.data.correct_answer_human[item.hash] : null;
                        return acc;
                    }, {});
                }
                if (data.question_type.code === 'PARAGRAPH_DRAG_CORRECT_SORT') {
                    this.form.data.data.drag_content_count = this.form.data.data.drag_content_count ?? 1;
                    this.form.data.correct_answer = this.form.data.correct_answer_human ?? [];
                }
                if (data.files) {
                    if (data.files.image) {
                        this.image.fileList = [
                            {
                                name: data.files.image.name,
                                url: data.files.image.public_url
                            }
                        ]
                    }
                    if (data.files.track) {
                        this.track.fileList = [
                            {
                                name: data.files.track.name,
                                url: data.files.track.public_url
                            }
                        ]
                    }
                }
                this.processLength = 0;
                this.errorLength = 0;
            })
        },
        loadTreeSections() {
            this.axios.get(this.endpoints['module_etep_section_type']).then((response) => {
                this.treeSections = response.data.data;
            });
        },
        loadQuestionType(cb) {
            this.axios.get(this.endpoints['module_etep_question_type'], {
                params: {
                    section_id: this.form.data.section_id,
                    // section_code: this.form.data.section_id,
                }
            }).then((response) => {
                this.questionTypes = response.data.data;
                this.subQuestionTypes = response.data.data;
                this.form.data.question_type_id = null;
                if (cb) {
                    cb();
                }
            });
        },
        loadTreeCategories() {
            this.axios.get(this.endpoints['module_etep_question_category'] + '/tree').then((response) => {
                this.treeCategories = response.data.data;
            });
        },
        changeQuestionType() {
            console.log(this.form.data.question_type_id)
        },
        onSubmit() {
            this.$refs.questionForm.validate(async (valid) => {
                if (valid) {
                    this.form.loading = true;

                    if (this.image.uploadList.length > 0 || this.track.uploadList.length > 0) {
                        this.submitFormWithUpload();
                    } else {
                        if (!(this.image.fileList.length > 0)) {
                            this.form.data.data.image_id = null;
                        }
                        if (!(this.track.fileList.length > 0)) {
                            this.form.data.data.track_id = null;
                        }
                        this.submitForm();
                    }
                } else {
                    return false;
                }
            });
        },
        submitForm() {
            let formData = this.prepareFormData();
            if (this.form.data.id) {
                new Promise((resolve, reject) => {
                    let request = [];

                    if (this.form.data.question_type.code === 'PARAGRAPH_DRAG_FILL') {
                        if (!formData.answers?.length) {
                            formData.correct_answer = null;
                        }
                    }
                    request.push(this.axios.put(this.endpoints['module_etep_question'] + '/' + this.form.data.id, formData));
                    this.form.data.sub_questions.forEach((sub, subIndex) => {
                        sub.question_id = this.form.data.id;
                        if (sub.id) {
                            request.push(this.axios.put(this.endpoints['module_etep_question_sub'] + '/' + sub.id, sub));
                            if (sub.answers?.length) {
                                sub.answers.forEach((answer) => {
                                    answer.question_id = this.form.data.id;
                                    answer.sub_question_id = sub.id;
                                    answer.content = answer.data.content;
                                    let formData = this.prepareFormAnswerData(answer);
                                    if (answer.id) {
                                        request.push(this.axios.put(this.endpoints['module_etep_question_answer'] + '/' + answer.id, answer));
                                    } else {
                                        request.push(this.axios.post(this.endpoints['module_etep_question_answer'], formData));
                                    }
                                })
                            }
                        } else {
                            sub.correct_answer = null;
                            request.push(this.axios.post(this.endpoints['module_etep_question_sub'], sub));
                        }
                    })
                    this.form.data.answers.forEach((answer, answerIndex) => {
                        answer.question_id = this.form.data.id;
                        answer.content = answer.data.content;
                        if (answer.id) {
                            request.push(this.axios.put(this.endpoints['module_etep_question_answer'] + '/' + answer.id, answer));
                        } else {
                            answer.correct_answer = null;
                            request.push(this.axios.post(this.endpoints['module_etep_question_answer'], answer));
                        }
                    })

                    this.axios.all(request).then(this.axios.spread((...responses) => {
                        let result = [];
                        for (let i = 0; i < responses.length; i++) {
                            let handleResponse = responses[i].data;
                            this.processLength++;
                            if (!handleResponse.status) {
                                this.errorLength++;
                                break;
                            }
                            result.push(handleResponse.data);
                        }

                        if (result.length === responses.length) {
                            resolve({status: true, data: result});
                            this.form.loading = false;
                            this.showResponse(responses)
                        } else {
                            reject('request_count_dont_match_with_response_count');
                            this.form.loading = false;
                            this.showResponse(responses)
                        }
                    })).catch((errors) => {
                        this.errorLength++;
                        this.form.loading = false;
                        reject('occurred_any_error');
                        this.showResponse(errors)
                    })
                });
            } else {
                this.axios.post(this.endpoints['module_etep_question'], formData).then(response => {
                    this.onResponse(response.data, () => {
                        let questionID = response.data.data.id;
                        this.$router.push({
                            path: "/module/etep/question/save/" + questionID
                        });
                        this.loadQuestion(questionID);
                    }, () => {
                        this.form.loading = false;
                    });
                }).catch(error => {
                    this.onResponseFailure(error.response.data, () => {
                        this.form.loading = false;
                    }, false);
                });
            }
        },
        prepareFormAnswerData(answer) {
            let data = this.cloneData(answer);
            return {...answer.translate, ...data}
        },
        prepareFormData() {
            let formData = this.form.data;

            return {...this.form.translate, ...formData}
        },
        showResponse(response) {
            if (this.errorStatus === 'successful') {
                response.status = true;
                this.onResponse(response);
                this.loadQuestion();
            } else if (this.errorStatus === 'failed') {
                response.status = false;
                this.onResponseFailure(response.response.data);
                this.loadQuestion();
            } else if (this.errorStatus === 'partiallySuccessful') {
                response.status = false;
                response.response.data.title = 'Kısmen Başarılı'
                response.response.data.type = 'warning'
                this.$notify(response.response.data);
                this.loadQuestion();
            }
        },
        submitFormWithUpload() {
            const formData = new FormData();

            this.track.uploadList.forEach(file => {
                formData.append("file[]", file.raw);
            });
            this.image.uploadList.forEach(file => {
                formData.append("file[]", file.raw);
            });

            this.axios.post(this.endpoints["file"], formData).then(response => {
                this.onResponse(response.data, () => {
                    let data = response.data.data;

                    const image = data.find(file => file.extension_detail.group === 'image');
                    const track = data.find(file => file.extension_detail.group === 'sound');

                    if (image) this.form.data.data.image_id = image.id;
                    if (track) this.form.data.data.track_id = track.id;
                    this.image.uploadList = [];
                    this.track.uploadList = [];
                }, () => {
                    this.submitForm();
                    this.form.loading = false;
                }, false);
            }).catch(error => {
                this.onResponseFailure(error, () => {
                    this.submitForm();
                });
            });
        },
        addAlertArea(type) {
            if (!this.form.data.data.alert_area) {
                this.form.data.data.alert_area = [];
            }
            this.form.data.data.alert_area.push({
                "type": type,
                "icon": "info",
                "color": "success",
                "content": "",
            })
        },
        removeAlertArea(index) {
            this.form.data.data.alert_area.splice(index, 1);
        },
    }
}
</script>

<style>
.overflow-visible-tabs .el-tabs__content {
    overflow: visible;
}

.overflow-visible-tabs .card-sticky-top {
    position: sticky;
    top: 140px;
}
</style>